import React, {Component, createRef} from 'react'
import FJLocalStore from "../../../store/FJLocalStore";

import FJButton from "fj-components/FJButton";
import FJVideoTapeTool from "./recordingScreen/FJVideoTapeTool";
import FJPreviewProjectController from "./recordingScreen/FJPreviewProjectController";

import styles from './FJRecordingModal.module.less';
import $ from 'jquery';
import FJCoreUtil from "../../../core/util/FJCoreUtil";
import classNames from "classnames"
import plusIcon from '../../../icon/plus.svg'
import FJLoadingImg from "../../../common/component/FJLoading/FJLoadingImg";

function FooterTwoBtn(props) {
  let {
    onCancel,
    onSubmit,
    cancelText,
    submitText,
    isShow
  } = props;
  return (
    <div className={styles.two_btn} style={{display: isShow ? 'flex' : 'none'}}>
      <div className={styles.btn_margin}>
        <FJButton className={ classNames(styles.btn, styles.re_record)} text={cancelText} size='large' type='cancel' onClick={onCancel}
                  textClass={styles.btn_font}
        />
      </div>
      <div className={styles.btn_margin}>
        <FJButton className={classNames(styles.btn, styles.btn_use)} icon={plusIcon} text={submitText} size='large' onClick={onSubmit} textClass={styles.btn_font} />
      </div>
    </div>
  );
}

class FJRecordingModal extends Component {

  constructor(props) {
    super(props);
    this.state = {
      num: 3,
      minute: '00',
      second: '00',
      volume: '',
      duration: '',
      title: 'record-webcam', // 标题
      imgUrl: '',
      recordType: 1, // 1：拍照 2：录像
      isLoading: true,
    };
    this._timeRecording = createRef();
    this._timeNum = createRef();
    this._video = createRef();
    this._previewVideo = createRef();
    this._playCrl = createRef();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.videotapeSrc !== this.props.videotapeSrc && this.props.videotapeSrc) {
      this._video.current.srcObject = this.props.videotapeSrc;
    }
  }

  /**
   * @description 用户点击截屏
   * @private
   */
  _readyToStartScreenshot = () => {
    this.setState({
      recordType: 1
    });
    this.props.setCurrentStage(2);
    this._showTimeDown();
  };

  /**
   * @description 显示拍照时间倒计时
   * @private
   */
  _showTimeDown = () => {
    $(this._timeNum.current).show();
    this.setState({num:3});
    this._timeOutDown = setInterval(()=> {
      let num = this.state.num - 1;
      if (num === 0) {
        clearInterval(this._timeOutDown);
        this._timeOutDown = null;
        this._hideTimeDown();

        let {recordType} = this.state;
        switch (recordType) {
          case 1:
            this.props.setCurrentStage(6);
            this._doScreenShot();
            break;
          case 2:
            this.props.setCurrentStage(4);
            this.props.startVideoBegins();
            this._timeShow();
            break;
          default:
        }

      }
      this.setState({num: num--});
    }, 1000)
  };

  /**
   * @description 隐藏时间倒计时
   * @private
   */
  _hideTimeDown = () => {
    $(this._timeNum.current).hide();
  };

  /**
   * @description 关闭倒计时
   * @private
   */
  _closeTimeDown = () => {
    clearInterval(this._timeOutDown);
    this._timeOutDown = null;
    this._hideTimeDown();
    this.setState({
      recordType: 1
    });
    this.props.setCurrentStage(1);
  };

  /**
   * @description 进行截屏操作
   * @private
   */
  _doScreenShot = () => {
    let canvas = document.createElement('canvas');
    let videoWidth = $(this._video.current)[0].videoWidth;
    let videoHeight = $(this._video.current)[0].videoHeight;
    canvas.width = videoWidth;
    canvas.height = videoHeight;
    let context = canvas.getContext('2d');
    context.drawImage(this._video.current, 0, 0, videoWidth, videoHeight);
    let url = canvas.toDataURL('image/png');
    this.setState({
      imgUrl: url
    });
    this.props.endRecording();
  };

  /**
   * @description 用户点击录像按钮
   * @private
   */
  _readyToStartRecording = () => {
    this.setState({
      recordType: 2
    });
    this._showTimeDown();
    this.props.setCurrentStage(3);
  };

  /**
   * @desc 录像时 显示录下录像时间
   * @private
   */
  _timeShow = () => {
    $(this._timeRecording.current).show();
    this.setState({
      minute: '00',
      second: '00'
    });

    if(typeof(Worker)!=="undefined") {
      this._startWorkerTiming();
      // 是的! Web worker 支持!
    } else {
      this._startTiming();
      // 抱歉! Web Worker 不支持
    }
  };

  /**
   * @desc 隐藏 录像时间
   * @private
   */
  timeHide = () => {
    this._timeHide();
  };
  _timeHide = () => {
    $(this._timeRecording.current).hide();
    this._endTiming();
  };

  /**
   * @desc 开始录制计时
   * @private
   */
  _startTiming = () => {
    let start;
    let _this = this;
    function step(timestamp) {
      if (!start) start = timestamp;
      let progress = Math.floor((timestamp - start) / 1000);
      let m = parseInt(progress / 60, 0) % 60;
      let s = progress % 60;

      if (m >= 10) {
        _this._stopRecording();
      } else {
        _this._timingOut = window.requestAnimationFrame(step);
      }

      m = m < 10 ? '0' + m : m;
      s = s < 10 ? '0' + s : s;
      _this.setState({
        minute: m,
        second: s
      });
    }
    this._timingOut = window.requestAnimationFrame(step);
  };

  /**
   * @desc 关闭录制计时
   * @private
   */
  _endTiming = () => {
    window.cancelAnimationFrame(this._timingOut);
    this._timingOut = null;
    this._endWorkerTiming();
  };

  /**
   * @desc 开始录像计时（worker）
   * @private
   */
  _startWorkerTiming = () => {
    let _this = this;
    let str;
    if (FJCoreUtil.getBrowser() === 'FF') {
      str = `
            let timeOut = null;
            let progress = 0;
            timeOut = setInterval(() => {
              progress++;
              let m = parseInt(progress / 60) % 60;
              if (m >= 1) {
                clearInterval(timeOut);
                timeOut = null;
                self.postMessage({timeOut: timeOut, seconds: 600})
                self.close()
              } else {
                self.postMessage({timeOut: timeOut, seconds: progress})
              }
            }, 1000);
        `;
    } else {
      str = `
            let timeOut = null;
            let start;
            function step(timestamp) {
                if (!start) start = timestamp;
                let progress = Math.floor((timestamp - start) / 1000);
                let m = parseInt(progress / 60) % 60;
                if (m >= 10) {
                    cancelAnimationFrame(timeOut)
                    self.postMessage({timeOut: timeOut, seconds: 600})
                    self.close()
                } else {
                    self.postMessage({timeOut: timeOut, seconds: progress})
                    timeOut = requestAnimationFrame(step)
                }
                
            };
            timeOut = requestAnimationFrame(step)
        `;
    }
    let blob = new Blob([str]);
    this._worker = new Worker(window.URL.createObjectURL(blob));

    this._worker.onmessage = function (e) {
      _this._timingOut = e.data.timeOut;
      let progress = e.data.seconds;
      let m = parseInt(progress / 60, 0) % 60;
      let s = progress % 60;

      if (m >= 10) {
        _this._worker.terminate();
        _this._stopRecording();
      }

      m = m < 10 ? '0' + m : m;
      s = s < 10 ? '0' + s : s;
      _this.setState({
        minute: m,
        second: s
      });
    }
  };

  /**
   * @desc 结束录像（worker）
   * @private
   */
  _endWorkerTiming = () => {
    this._worker && this._worker.terminate();
    this._worker = null;
  };


  /**
   * @description 用户点击停止录像
   * @private
   */
  _stopRecording = () => {
    this.props.setCurrentStage(7);
    this._timeHide();
    this.props.endRecording();
  };

  /**
   * @description video开始加载
   * @private
   */
  _onLoadStart = () => {
    this.setState({isLoading: true});
  };

  /**
   * @description 加载成功
   * @private
   */
  _onLoadSuccess = () => {
    if (Infinity === this._previewVideo.current.duration) {
      // 流媒体无法通过metadata获取时长
      this._previewVideo.current.currentTime = 1e10;
      this._previewVideo.current.ondurationchange = () => {
        this._previewVideo.current.ondurationchange = null;
        this._previewVideo.current.currentTime = 0;
        this._setVideoInfo();
      };
    } else {
      this._setVideoInfo();
    }

  };

  _setVideoInfo = () => {
    this.setState({
      isLoading: false,
      duration: this._previewVideo.current.duration,
      volume: this._previewVideo.current.volume,
    }, () => {
      // this._play();
    });
  };

  /**
   * @description 加载失败
   * @private
   */
  _onLoadError = () => {
  };

  /**
   * @description 用户点击退出
   * @private
   */
  _onCancel = () => {
    // currentStage: 1, 0:初始化状态, 1：显示录像内容， 2：拍照倒计时中, 3:录像倒计时, 4:录像中，5:录屏中， 6：拍照预览， 7：录像预览, 8:录屏预览
    let {currentStage} = this.props;
    if (currentStage === 1 || currentStage === 2 || currentStage === 3) {
      this._closeTimeDown();
    }

    this.props.onCancel(currentStage);
  };

  /**
   * @description 播放视频
   * @private
   */
  _play = () => {
    let _this = this;
    function videoPlay() {
      let progress = _this._previewVideo.current.currentTime / _this.state.duration;
      _this._playCrl.current.updateProgress(progress);
      if (progress >= 1) {
        _this._playCrl.current.updateProgress(0);
        _this._playCrl.current.changePlayState(false);
        _this._clearVideo();
      } else {
        _this._videoTimeOut = window.requestAnimationFrame(videoPlay);
      }
    }
    this._videoTimeOut = window.requestAnimationFrame(videoPlay);
    this._previewVideo.current.play();
    this._playCrl.current.changePlayState(true);

  };

  /**
   * @description 暂停
   * @private
   */
  _pause = () => {
    this._previewVideo.current.pause();
    this._clearVideo();
  };

  /**
   * @description 清除计时器
   * @private
   */
  _clearVideo = () => {
    window.cancelAnimationFrame(this._videoTimeOut);
    this._videoTimeOut = null;
  };

  /**
   * @description 设置音量
   * @param value
   * @private
   */
  _previewVolumeChange = (value) => {
    this._previewVideo.current.volume = value;
  };

  /**
   * @description 设置进度
   * @param progress
   * @private
   */
  _sliderDataChange = ({progress}) => {
    this._previewVideo.current.currentTime = progress * this.state.duration;
  };

  /**
   * @description 清除页面的定时器或者其他需要初始化的
   */
  clearAll = () => {
    this._clearVideo();
    this._timeHide();
  };

  /**
   * @description 外部调用点击退出
   */
  userClickClose = () => {
    this._onCancel();
  };

  render() {
    let {
      videoSource,
      cameraList,
      microphoneList,
      cameraActiveIndex,
      microphoneActiveIndex,
      changeRecordingConfig,
      currentStage, // 0:初始化状态, 1：显示录像内容， 2：拍照倒计时中, 3:录像倒计时, 4:录像中，5:录屏中， 6：拍照预览， 7：录像预览, 8:录屏预览

      // onCancel,
      onReRecord,
      onSubmit,
    } = this.props;

    let {
      minute,
      second,
      num,
      imgUrl,
      isLoading,
      duration
    } = this.state;


    let cancelText;
    if (currentStage === 7 || currentStage === 8) {
      cancelText = FJLocalStore._('re-record');
    } else if (currentStage === 6) {
      cancelText = FJLocalStore._('re-photograph');
    }

    return (
      <div className={styles.container}>
        <div className={styles.content} style={{height: this.props.videoHeight + 'px'}}>
          {
            currentStage === 6 ? <img className={styles.image} src={imgUrl} alt=""/> : null
          }

          <div className={styles.loading} style={{display: isLoading && (currentStage === 7 || currentStage === 8) ? 'block' : 'none'}}>
            <FJLoadingImg className={ classNames( styles.img )} />
          </div>

          {
            videoSource ? <video style={{opacity: isLoading ? 0 : 1,}}
                                 ref={this._previewVideo}
                                 className={styles.video}
                                 src={videoSource}
                                 onLoadStart={this._onLoadStart}
                                 onLoadedData={this._onLoadSuccess}
                                 onError={this._onLoadError}
            /> : null
          }
          <video style={{display: currentStage >= 6 ? 'none' : 'block'}} ref={this._video} className={styles.video} autoPlay muted />

          <div className={styles.time_box} ref={this._timeRecording}>
            <div className={styles.time}>
              <i className={styles.red_dot + ' i-twinkle-active'} />
              <p className={styles.p_show}>{minute}:{second}/10:00</p>
            </div>
          </div>
          <div className={styles.count_down} ref={this._timeNum}>{num}</div>

          {
            currentStage === 7 || currentStage === 8 ?
              <FJPreviewProjectController play={this._play}
                                          pause={this._pause}
                                          previewVolumeChange={this._previewVolumeChange}
                                          ref={this._playCrl}
                                          dataChange={this._sliderDataChange}
                                          duration={duration} /> : null
          }

        </div>
        <div className={styles.footer}>

          <FooterTwoBtn onCancel={onReRecord}
                        onSubmit={() => {
                          onSubmit(imgUrl, duration)
                        }}
                        cancelText={cancelText}
                        submitText={FJLocalStore._('add-to-media-library')}
                        isShow={currentStage === 6 || currentStage === 7 || currentStage === 8}
          />

          <FJVideoTapeTool isShow={currentStage === 1 || currentStage === 4}
                           currentStage={currentStage}
                           readyToStartScreenshot={this._readyToStartScreenshot}
                           readyToStartRecording={this._readyToStartRecording}
                           stopRecording={this._stopRecording}
                           cameraList={cameraList}
                           microphoneList={microphoneList}
                           cameraActiveIndex={cameraActiveIndex}
                           microphoneActiveIndex={microphoneActiveIndex}
                           changeRecordingConfig={changeRecordingConfig}
          />

        </div>
      </div>
    );
  }
}


export default FJRecordingModal;
